import { OpenInNew } from '@mui/icons-material';
import { Button, Chip, Grid, Icon, Paper, Tooltip } from '@mui/material';
import { Invoice } from '@thro-types/jobmarket';

import { invoiceDownload } from 'api';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { handleDownload } from 'app/components/Util/downloadAttachement';
import { translations } from 'locales/i18n';

import { GridWeight } from '../..';

export const InvoiceId = (invoice: Invoice) => (
  <Grid item xs={1} className="invoice-item__id">
    {invoice.id}
  </Grid>
);

export const CompanyName = (invoice: Invoice, weight: GridWeight = 3) => (
  <Grid item xs={weight} className="invoice-item__name">
    <a href={`/companies/${invoice.company?.id}`} target="_blank" rel="noopener noreferrer">
      <Grid container>
        [{invoice.company?.id}] {invoice.company?.name}
      </Grid>
    </a>
  </Grid>
);

export const OfferId = (invoice: Invoice) => (
  <Grid item xs={1} className="invoice-item__offer-id">
    {invoice.jobOffering?.id}
  </Grid>
);

export const OfferName = (invoice: Invoice) => (
  <Grid item xs={2} className="invoice-item__id">
    {invoice.jobOffering?.title}
  </Grid>
);

export const KSNumber = (invoice: Invoice, t: TFunction, weight: GridWeight = 2) => (
  <Grid item xs={weight} className="invoice-item__invoice-number">
    {invoice.ksNumber?.number || t(translations.common.notAvailableYet())}
  </Grid>
);

export const StokNumber = (invoice: Invoice, t: TFunction, weight: GridWeight = 2) => (
  <Grid item xs={weight} className="invoice-item__invoice-number">
    {invoice.stokNumber?.number || t(translations.common.notAvailableYet())}
  </Grid>
);

export const CreatedAt = (invoice: Invoice, weight: GridWeight = 2) => (
  <Grid item xs={weight} className="invoice-item__created-at">
    <Chip
      component={Paper}
      icon={
        <Icon
          className="far fa-calendar-alt"
          style={{
            width: 'auto',
            marginLeft: '0.5em',
            marginRight: '0'
          }}
        />
      }
      label={new Date(invoice.createdAt).toLocaleDateString()}
    />
  </Grid>
);

export const Amount = (invoice: Invoice, weight: GridWeight = 2) => (
  <Grid item xs={weight} className="invoice-item__open-amount">
    {invoice.addTax ? (
      <Tooltip title="Brutto" placement="top">
        <Chip
          className="invoice-item__open-amount--brutto"
          component={Paper}
          icon={
            <Icon
              className="fas fa-euro-sign"
              style={{
                width: 'auto',
                marginLeft: '0.5em',
                marginRight: '0'
              }}
            />
          }
          label={invoice.brutto?.toFixed(2)}
        />
      </Tooltip>
    ) : (
      <Tooltip title="Netto" placement="top">
        <Chip
          className="invoice-item__open-amount--netto"
          component={Paper}
          icon={
            <Icon
              className="fas fa-euro-sign"
              style={{
                width: 'auto',
                marginLeft: '0.5em',
                marginRight: '0'
              }}
            />
          }
          label={invoice.netto?.toFixed(2)}
        />
      </Tooltip>
    )}
  </Grid>
);

export const CancellationReason = (invoice: Invoice, weight: GridWeight = 3, prefix?: string) => (
  <Grid item xs={weight} className="invoice-item__cancellation-reason">
    {prefix || null}
    {invoice.cancellationReason}
  </Grid>
);

export const OpenDMS = (invoice: Invoice, weight: GridWeight = 2) => {
  const { t } = useTranslation();
  return (
    <Grid item className="invoice-item__actions">
      <Tooltip title={t(translations.pages.invoices.openInDMS())}>
        <Button variant="contained" href={invoice.dmsLink || ''} target="_blank">
          <OpenInNew />
        </Button>
      </Tooltip>
    </Grid>
  );
};

export const DownloadPDF = (invoice: Invoice, label: string, weight: GridWeight = 2) => {
  const { t } = useTranslation();
  if (label)
    return (
      <Grid item xs={weight} className="invoice-item__actions">
        <Tooltip title={t(translations.common.download())}>
          <Button
            variant="contained"
            onClick={() => {
              handleDownload(invoice.filename, invoiceDownload(invoice.id));
            }}
            startIcon={
              <Icon
                className="far fa-file-pdf"
                style={{
                  width: 'auto',
                  marginRight: '0'
                }}
              />
            }
            color="primary"
          >
            {label}
          </Button>
        </Tooltip>
      </Grid>
    );
  else
    return (
      <Tooltip title={t(translations.common.download())}>
        <Button
          variant="contained"
          onClick={() => {
            handleDownload(invoice.filename, invoiceDownload(invoice.id));
          }}
          color="primary"
        >
          <Icon
            className="far fa-file-pdf"
            style={{
              width: 'auto',
              marginRight: '0'
            }}
          />
        </Button>
      </Tooltip>
    );
};
